import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import {
  CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
  CS_INQUIRY_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/inquiry/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { CS_INQUIRY_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/csInquiryConstants';
import columns from './columns';

const CsInquiryList = (props) => {
  const { csInquiryList, getList, getExcelDownload } = props;
  const { list, filterOption, sortOption, pagination, summary } = csInquiryList;

  return (
    <div className="cs-inquiry-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: CS_INQUIRY_LIST_FILTER_OPTION_MODEL,
          sortOption: CS_INQUIRY_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={CS_INQUIRY_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default CsInquiryList;
